import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/news/NewsListClient.tsx");
